var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entry-instructions"},[_c('p',{staticClass:"text-muted"},[_vm._v("Your entries are automatically saved as you type.\n        You don't need to click anything when you are done.")])])
}]

export { render, staticRenderFns }